import React, { useState } from 'react';
import ComPatSearch from './ComPatSearch';
import SearchStaffUser from '../../Utilities/SerchStafUser';
import CommonUploadFile from '../../Utilities/CommonUploadFile';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import ComGrpSearchSpan from './ComGrpSearchSpan';
import { useSelector } from 'react-redux';

function ComStaffMsgCompose({ close, handleReload }) {
  const { user } = useSelector((state) => state.auth);
  const [selectedPats, setSelectedPats] = useState([]);
  const [taggedStaff, setTaggedStaff] = useState([]);
  const [attachments, setAttachments] = useState('');
  const [subject, setSubject] = useState('');
  const [textMgStr, setTextMgStr] = useState('');

  const handleSendIntraMsg = async () => {
    let prams = {
      parentId: '',
      subject: subject,
      to: taggedStaff.map((item) => item.staff_id).join(','),
      compose_message: textMgStr,
      attachments: attachments,
      attachedPatientIds: selectedPats,
      loginUserId: user?.id,
    };
    if (!prams?.to) {
      setUiMessage('err', "Please select 'To' user.");
    } else if (!prams.compose_message) {
      setUiMessage('err', 'Please write some message.');
    } else {
      try {
        const response = await post(
          'api/communication/Communication/sendIntraMsg',
          {
            ...prams,
          }
        );

        if (response.status === 200) {
          if (response?.data?.status === 'success') {
            setUiMessage('suc', 'Message sent successfully.');
            handleReload();
            close();
          } else {
            setUiMessage('err', response?.data?.msg);
          }
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      }
    }
  };

  return (
    <>
      <div className="modalBackground">
        <div className="compose-msg-main-con grid-sec tab-bg">
          <div className="comp-msg-hdr flex-sec">New Message (Staff)</div>
          <div className="comp-msg-bdy grid-sec">
            <ComGrpSearchSpan
              handleTaggedStaff={(staffs) => setTaggedStaff(staffs)}
            />
            <SearchStaffUser
              fieldName={'To'}
              key={Math.random()} // Ensure re-rendering when the key changes
              tagStaffUser={taggedStaff}
              handleTaggedStaff={(staffs) => setTaggedStaff(staffs)}
            />
            <ComPatSearch
              bigSearchBox={true}
              fieldName={'Attach Patient'}
              changeShow={false}
              handlePatArr={(selectedPats) => setSelectedPats(selectedPats)}
              returntype={'str'}
            />
            <div
              className="comp-msg-bdy-rw grid-sec"
              style={{ position: 'relative ' }}
            >
              <div className="comp-msg-bdy-chld-rw flex-sec">
                <span className="msg-bdy-rw-bl">Attach Document:</span>
                <span className="msg-bdy-rw-val">
                  <CommonUploadFile
                    // lable={'Document'}
                    apiUri={'api/communication/Communication/fileToUpload'}
                    handleUploadFile={(files) => setAttachments(files)}
                  />
                </span>
              </div>
            </div>

            <div
              className="comp-msg-bdy-rw grid-sec"
              style={{ position: 'relative' }}
            >
              <div className="comp-msg-bdy-chld-rw flex-sec">
                <span className="msg-bdy-rw-bl">Subject:</span>
                <span className="msg-bdy-rw-val">
                  <div className="comp-msg-bdy-chld-rw flex-sec">
                    <span className="msg-bdy-rw-val" style={{ width: '100%' }}>
                      <input
                        type="text"
                        className="msg-inpt"
                        placeholder="Write the subject of the message"
                        style={{ width: '92%' }}
                        value={subject}
                        onChange={(e) => {
                          setSubject(e.target.value);
                        }}
                      />
                    </span>
                  </div>
                  {/* <ComEmailSubject
                    handleSubjectReturn={(sub) => {
                      setSubject(sub);
                    }}
                    mode=""
                  /> */}
                </span>
              </div>
            </div>
            <div className="comp-msg-bdy-rw flex-sec">
              <span className="msg-bdy-rw-bl">Message:</span>
              <span className="msg-bdy-rw-val">
                <textarea
                  className="msg-bdy"
                  placeholder="Write yor Message here"
                  // value="Please see the attached document"
                  onChange={(e) => setTextMgStr(e.target.value)}
                  value={textMgStr}
                ></textarea>
              </span>
            </div>
          </div>
          <div className="comp-msg-ftr flex-sec">
            <button className="actn-yes" onClick={handleSendIntraMsg}>
              Send
            </button>
            <button className="actn-No" onClick={close}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ComStaffMsgCompose;
